import { module } from 'angular';

import { default as filterDirectiveName, FilterDirective } from './filter.directive';

export default module('contact.commons.toolbox.filter', []).directive(filterDirectiveName, FilterDirective).name;
